import { render, staticRenderFns } from "./EventRatingTransaction.vue?vue&type=template&id=476e67a6&scoped=true"
import script from "./EventRatingTransaction.vue?vue&type=script&lang=js"
export * from "./EventRatingTransaction.vue?vue&type=script&lang=js"
import style0 from "./EventRatingTransaction.vue?vue&type=style&index=0&id=476e67a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476e67a6",
  null
  
)

export default component.exports